module.exports = __webpack_public_path__ + "img/lunbo122.e18f39e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo122.png
// module id = wU35
// module chunks = 0